$(document).foundation();

jQuery(document).ready(function($) {

	mainHandler.init();
	homeHandler.init();
	aboutHandler.init();
	newsHandler.init();
	gfHandler.init();
	gwHandler.init();
	peopleHandler.init();
	offSeasonHandler.init();
	announcementHandler.init();
	
	//document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');
	if ( ($('.page-template-page-off-season main, .page-template-page-annual-event main, .single-festival main').length > 0) ) {
		festivalHandler.init();
	}

	if ($('.page-template-page-financials main').length > 0) {
		financialsHandler.init();
	}

	if ($('.tribe-events-page-template main').length > 0) {
		eventsHandler.init();
	}
	
		// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		$(this).parent().addClass('responsive-embed widescreen')
	})

	

})
